import { colors } from '@ardoq/design-tokens';
import styled, { css } from 'styled-components';
import {
  VIEW_SCROLLBAR_WIDTH_CSS_VARIABLE,
  VISUALIZATION_CONTENT_CONTAINER_CLASS_NAME,
  X_AXIS_CONTAINER_CLASS_NAME,
} from '@ardoq/global-consts';

export const DependencyMatrixTable = styled.table.attrs({
  className: `${VISUALIZATION_CONTENT_CONTAINER_CLASS_NAME}`,
})<{ $isReadOnly: boolean; $isExporting?: boolean }>`
  table-layout: fixed;
  border-collapse: initial;
  width: 1px; /* Hack to left-align the fixed table */

  ${({ $isReadOnly }) =>
    !$isReadOnly &&
    css`
      td {
        cursor: cell;
      }
    `}

  ${({ $isExporting }) =>
    !$isExporting &&
    css`
      tbody tr:hover th,
      tbody tr:hover td,
      td.hover {
        background-color: ${colors.grey50};
      }
    `}
`;

export const ColumnHeaderBackground = styled.div.attrs({
  className: X_AXIS_CONTAINER_CLASS_NAME,
})`
  width: calc(100% - var(${VIEW_SCROLLBAR_WIDTH_CSS_VARIABLE}));
  position: absolute;
  pointer-events: none;
  max-width: 100%;
  height: 140px;
  top: 0;
  left: 0;
  border-bottom: 1px solid ${colors.grey300};
  border-right: 1px solid ${colors.grey300};
  background-color: ${colors.white950};
`;
